export enum SearchableEntities {
  BOOKING = 'BOOKING',
  INVOICE = 'INVOICE',
  LISTING_UNIT = 'LISTING_UNIT',
  LISTING = 'LISTING',
  USER = 'USER',
}
